import { render, staticRenderFns } from "./RegularTitle.vue?vue&type=template&id=2bf56d2a&scoped=true&name=regular-title&"
import script from "./RegularTitle.vue?vue&type=script&lang=js&"
export * from "./RegularTitle.vue?vue&type=script&lang=js&"
import style0 from "./RegularTitle.vue?vue&type=style&index=0&id=2bf56d2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf56d2a",
  null
  
)

export default component.exports